import styles from './style.css'
import {connect} from 'react-redux'
import { push } from 'react-router-redux'

class NotFound extends React.Component {
  shouldComponentUpdate (nextProps, nextState) {
    return false
  }

  componentDidMount () {
    let divScroll = $('.div-scroll')
    let tableScroll = $('.table-scroll')
    let tbodyInner = $('#tbodyinner')
    divScroll.scroll(this._handleScroll)
    tableScroll.scroll(this._handleTableScroll)
    tbodyInner.scroll(this._handleTbodyInner)
  }

  _handleScroll = () => {
    let divScroll = $('.div-scroll')
    document.getElementById('tbodyinner').scrollLeft = divScroll.scrollLeft()
  }

  _handleTableScroll = () => {
    let tableScroll = $('.table-scroll')
    var widthDiv = tableScroll.scrollLeft() + tableScroll.width()
    document.getElementById('tbodyinner').style.width = widthDiv + 'px'
  }

  _handleTbodyInner = () => {
    let tbodyInner = $('#tbodyinner')
    document.getElementById('tbodydiv').scrollTop = tbodyInner.scrollTop()
  }

  render () {
    return (
      <div className='row'>
        <div className={styles['dialog']}>
          <h1 className={styles['textNotFound']}>The page you were looking for doesnt exist.</h1>
          <p>You may have mistyped the address or the page may have moved.</p>
        </div>
        <p className={styles['pageNotFound']}>
          <button
            className={`btn btn-default ${styles['btn-back']} mr-10px`}
            onClick={this._onClickBackToDashboard}
            type='button'>Back to Dashboard
          </button>
        </p>
      </div>)
  }
  _onClickBackToDashboard = (e) => {
    e.preventDefault()
    e.stopPropagation()
    const {loggedIn} = this.props.data.loggedIn
    if (!loggedIn) {
      this.props.dispatch(push('/'))
    } else {
      this.props.dispatch(push('/dashboard'))
    }
  }
}

function mapStateToProps (state) {
  return {
    data: state.moka
  }
}

export default connect(mapStateToProps)(NotFound)



// WEBPACK FOOTER //
// ./app/pages/NotFound/NotFound.js